import React, {Fragment} from 'react'

import withApiService from '../hoc/with-api-service'
import withData from '../hoc/with-data'

import ProductList from '../product-list'
import CatalogueContentTitle from './catalogue-content-title'
import SortBy from '../sort-by'
import Paginator from '../paginator';

const CatalogueContent = ({response, categoryId, setCurrentCategory, currentPage,
                            setCurrentPage, sortBy, setSortBy}) => {

  const {data, pages, goods} = response;

  return (
    <Fragment>
      <section className="product-catalogue__head">
        <CatalogueContentTitle categoryId={categoryId}
                               setCurrentCategory={setCurrentCategory}
                               goods={goods && goods}/>
        <SortBy sortBy={sortBy}
                setSortBy={setSortBy}/>
      </section>
      <section className="product-catalogue__item-list">
        <ProductList data={data}
                     page="product-card-desktop"/>
      </section>
      {(pages && data && data.length) ?
        (<div className="product-catalogue__pagination">
          <Paginator currentPage={currentPage}
                     pages={pages}
                     setCurrentPage={setCurrentPage}/>
        </div>) :
        false}
    </Fragment>
  )
};

const mapMethodsToProps = (apiService) => {
  return {
    getData: apiService.getProducts
  };
};

export default withApiService(mapMethodsToProps)(withData(CatalogueContent))
